export default __webpack_public_path__ + "static/media/logo-dark.3fb058fb.png";